module.exports = __webpack_public_path__ + "img/t9-1rse.ab27187c.svg";